import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { TranslateModule } from '@ngx-translate/core';
import { StyleDirectionService } from '../../services/style-direction.service';
import { SlideService } from '../../appshared/web/slide/slide.service';
import { SlideModule } from '../../appshared/web/slide/slide.module';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [CommonModule, SlickCarouselModule, TranslateModule],
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.css'],
})
export class HeroComponent {
  slides: SlideModule[] = [];
  comID = 1;
  currentLang: string = localStorage.getItem('locale') || 'en';
  public apiURL: string = '';

  constructor(
    private styleDirectionService: StyleDirectionService,
    private SlideService: SlideService
  ) {}

  ngOnInit(): void {
    this.styleDirectionService.dirMode$.subscribe((isRtl) => {
      this.slideConfig = {
        ...this.slideConfig,
        rtl: isRtl,
      };
    });
    this.getSlides();
    this.apiURL =
      environment.apiUrl2 + 'Attachment/Companies/' + this.comID + '/GnAtt/';
  }
  getSlides() {
    this.SlideService.getService(this.comID, 'Slide').subscribe(
      (res) => {
        this.slides = res;
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    dots: true,
    arrows: true,
    rtl: false,
  };
}
